import './Home.css';

const experiences = [
    {
        company: 'Timestamp',
        role: 'Sysadmin SAS',
        period: '07/2025 - 05/2026',
        summary:
            'At Timestamp I worked as a SAS sysadmin. I helped keep the SAS environments running, checked problems when they appeared, and supported the people using the platform.',
        highlights: [
            'SAS platform administration and support.',
            'Monitoring, troubleshooting, and small operational fixes.',
            'First real contact with production systems and support work.',
        ],
    },
    {
        company: 'CTW',
        role: 'C++ Developer',
        period: '05/2026 - Now',
        summary:
            'At CTW I work as a C++ developer. The work is more focused on code, debugging, and understanding how a larger codebase is put together.',
        highlights: [
            'C++ development and maintenance.',
            'Debugging issues and reading existing code.',
            'Learning to write clearer code and think more carefully before changing things.',
        ],
    },
];

function Career() {
    return (
        <main className="career-page">
            <section className="career-intro">
                <h1>Career</h1>
                <p>
                    I started working closer to systems and support, and now I am working more directly with
                    software development. Still early, but already learning a lot from both sides.
                </p>
            </section>

            <section className="career-timeline" aria-label="Professional experience">
                {experiences.map((experience) => (
                    <article className="career-card" key={`${experience.company}-${experience.role}`}>
                        <div className="career-card-header">
                            <div>
                                <p className="career-company">{experience.company}</p>
                                <h2>{experience.role}</h2>
                            </div>
                            <span className="career-period">{experience.period}</span>
                        </div>

                        <p className="career-summary">{experience.summary}</p>

                        <ul className="career-highlights">
                            {experience.highlights.map((highlight) => (
                                <li key={highlight}>{highlight}</li>
                            ))}
                        </ul>
                    </article>
                ))}
            </section>
        </main>
    );
}

export default Career;
